import React from 'react';

import { RouteDictionary } from '../../../../utils';
import { TertiaryButtonColor } from '../../../common/buttons/decorators/TertiaryButton/TertiaryButton';
import { TextColor } from '../../../common/typography/texts/ColoredText/ColoredText';
import { Block, ColoredText, CustomLink, Flex, TertiaryButton } from '../../../index';
import { AlignItems, JustifyContent } from '../../../layout/Flex/Flex';
import { TransactionStats } from '../../index';

import './Transactions.scoped.scss';

const Transactions = () => {
  return (
    <div className="my-money__transactions">
      <Block>
        <Block.Content>
          <Block.Header className="my-money__block-header" withPadding>
            <Flex alignItems={AlignItems.CENTER} justifyContent={JustifyContent.BETWEEN}>
              <div className="my-money__heading">Транзакции</div>
              <div>
                <ColoredText color={TextColor.PRIMARY_GREEN}>
                  <CustomLink to={RouteDictionary.TRANSACTIONS}>Подробнее</CustomLink>
                </ColoredText>
              </div>
            </Flex>
          </Block.Header>
          <Block.Body className="my-money__transactions-body">
            <TransactionStats />
          </Block.Body>
          <div className="my-money__transactions-footer">
            <TertiaryButton expanded color={TertiaryButtonColor.GRAY}>
              <CustomLink to={RouteDictionary.TRANSACTIONS}>Ещё</CustomLink>
            </TertiaryButton>
          </div>
        </Block.Content>
      </Block>
    </div>
  );
};

export default Transactions;
